module.exports = __webpack_public_path__ + "static/object-recordtypes.24097932.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/products/realfire/features/view-object-details/object-recordtypes.png
// module id = 267
// module chunks = 62430881213916 95704636617618